const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import RankView from "./rank_view";
import ModelData from "../../../public/model_data";

@ccclass
@moduleInit("Rank")
export default class Rank extends ModuleBase<RankView, null>  {
    curShowType = null
    rankDataByType = []
    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/hall/module/rank/rank';       
        this.viewType = RankView;
    }

    onShow(intentData) {
        this.rankDataByType = intentData
        this.view.tweenTo()
        this.chooseShowRank(1)
    }


    protected onButtonClickName(name : string) {
        let self = this
        switch (name) {
            case "CaiFuBtn":
                this.chooseShowRank(1)
                break;
            case "WinGoldBtn":
                this.chooseShowRank(2)
                break;
            case "Mask":
                this.view.tweenTo(null, true, ()=>{
                    self.hide()
                })
                break
            default:
                break;
        }
    }

    chooseShowRank(changeType){
        if (this.curShowType == changeType){ return }
        this.curShowType = changeType
        if (this.rankDataByType[this.curShowType] == null){
            this.getRankDataByType(this.curShowType)
        }
        else{
            this.view.changeRankType(this.curShowType)
            this.view.updateShow(this.rankDataByType[this.curShowType].rankItems, this.rankDataByType[this.curShowType].userRankItem)
        }
    }

    //获取财富排行榜数据  
    //@param 1-财富榜,2-赢金排行榜
    getRankDataByType(rankType){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "rank/getRank?",
            params: {
                rankType: rankType,
                gameUserId:ModelData.instance.roleData.id,
            },
        }
        this.apiHttpGet(requestData, (respone) => {
            self.rankDataByType[rankType] = respone.data
            self.view.changeRankType(this.curShowType)
            self.view.updateShow(respone.data.rankItems, respone.data.userRankItem)//更新数据
        })
    }

    
}